import { useForm } from '@mantine/form';
import { useTranslation } from 'react-i18next';

export const useAssetInviteUsersForm = () => {
  const { t } = useTranslation();

  const form = useForm({
    initialValues: {
      emails: [{ email: '' }],
    },
    validate: {
      emails: {
        email: value => (/^\S+@\S+$/.test(value) ? null : t('forms.invalidEmail', 'Mail invalide')),
      },
    },
  });

  const addEmail = () => {
    form.insertListItem('emails', { email: '' });
  };

  const removeEmail = (index: number) => {
    if (form.values.emails.length > 1) {
      form.removeListItem('emails', index);
    }
  };

  return { form, addEmail, removeEmail };
};
